
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 52 52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.864 11.096c.71 0 1.37.127 1.98.38.61.254 1.151.618 1.625 1.092.474.474.83 1.008 1.066 1.6.237.592.373 1.261.407 2.006 0 .677-.127 1.329-.381 1.955a4.928 4.928 0 01-1.092 1.65l-20.16 20.186a4.927 4.927 0 01-1.65 1.092 5.529 5.529 0 01-1.956.406 5.156 5.156 0 01-1.955-.381 4.754 4.754 0 01-1.65-1.117l-9.192-9.192a4.928 4.928 0 01-1.091-1.65 5.529 5.529 0 01-.407-1.955c0-.711.136-1.371.407-1.98.27-.61.634-1.151 1.091-1.625.458-.474.99-.83 1.6-1.067a6.31 6.31 0 012.006-.406c.677 0 1.329.127 1.955.38a4.927 4.927 0 011.65 1.093l5.586 5.585 16.555-16.58a4.927 4.927 0 011.65-1.091 5.156 5.156 0 011.956-.381z","fill":"#27AE45"}})])
          )
        }
      }
    